import { request } from '@/utils'

export default {
  getInGoodsList: (params: PageParams) =>
    request.post(`/warehouse/inGoods/list?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`, params.body || {}),
  getInGoodInfoById: (id: string) => request.get(`/warehouse/inGoods/get/${id}`),
  confirmIn: (id: string, data: { ids: Array<string | number> }) => request.post(`/warehouse/inGoods/sureGoodsIn?id=${id}`, data),
  confirmInBatch: (data: any[]) => request.post(`/warehouse/inGoods/sureGoodsInBatch`, data),
  getDirectionByCode: (code: string) => request.get(`/system/diction/findByCode/${code}`),
  getStoreHouses: () => request.get('warehouse/storehouse/getFormList'),
  getCategoryCascade: () => request.get('/purchase/purchase/supply/service/type/categoryCascadeQuery'),
  getBrandCascade: () => request.get('/purchase/purchase/supply/service/type/brandCascadeQuery'),
  getAllType: (type: string) => request.get(`/purchase/purchase/materials/getAllType?goodsCategory=${type}`),
  // 仓库列表
  getStockFormList: () => request.get('/warehouse/storehouse/getFormList'),
}
